import request from './request';

const uri = 'city';

const city = {
  get: (id = '', options) => request(uri + id, options),
};

export default city;
